import {
  OfferAssetDto,
  OfferDocumentDto,
  OfferDocumentTypeDto,
  OfferExternalDetailsDto,
  OfferOptionTypeDto,
  PublicOfferCardPaymentAccountDto,
} from 'src/dtos/offers.dtos';

export class OfferDocument {
  private _id: string;
  private _url: string;
  private _type: OfferDocumentTypeDto;
  private _label: string;

  constructor(document: OfferDocumentDto) {
    this._id = document.id;
    this._url = document.url;
    this._type = document.type;
    this._label = this.findLabel();
  }

  private findLabel(): string {
    switch (this._type) {
      case 'investor_presentation':
        return 'Investor Presentation';
      case 'offering_summary':
        return 'Offering Summary';
      case 'offering_document':
        return 'Offering Documents';
      case 'risk_factors':
        return 'Risk Factors';
      case 'subscription_agreement':
        return 'Subscription Agreement';
      case 'circular_offering_document':
        return 'Circular Offering Document';
      default:
        return '';
    }
  }

  get id(): string {
    return this._id;
  }

  get url(): string {
    return this._url;
  }

  get type(): OfferDocumentTypeDto {
    return this._type;
  }

  get label(): string {
    return this._label;
  }
}

export interface OfferOption {
  id: string;
  type: OfferOptionTypeDto;
  name: string;
}

export interface Offer {
  id: string;
  name: string;
  new: boolean;
  isComingSoon: boolean;
  isRecurring: boolean;
  closeDate: string | null;
  closeDates: Date[];
  minimumInvestCurrencyAmt: number;
  yield: string;
  status: string;
  offerType: string;
  industry: string;
  category: string;
  securityType: string;
  logoUrl: string | null;
  shortUrlRoute: string | null;
  videoThumbnailUrl: string | null;
  assets: OfferAssetDto[];
  featured: boolean;
  ordersSummation?: string | null;
  allowAchTransfers: boolean;
  allowWireTransfers: boolean;
  allowCheckTransfers: boolean;
  allowCardPayments: boolean;
  allowAcatTransfers: boolean;
  allowIraContributionWireTransfers: boolean;
  allowIraContributionCheckTransfers: boolean;
  allowDirectFromIdenticalIraWireTransfers: boolean;
  totalCapitalRaised?: number;
}

export interface OfferDetails extends Offer {
  isExternalOffer: boolean;
  description: string;
  disclaimer: string;
  yieldDescription: string;
  exitDescription: string;
  subtextOnClosed: string;
  pricePerShare: number;
  maximumInvestCurrencyAmt: number;
  minTotalRaiseCurrencyAmt: number;
  maxTotalRaiseCurrencyAmt: number;
  minSharePrice?: number;
  maxSharePrice?: number;
  isConditional: boolean;
  startDate?: string;
  sector: string;
  videoUrl: string | null;
  documents: OfferDocument[];
  featured: boolean;
  ordersSummation: string | null;
  anticipatedStartDate: string | null;
  investmentRanges: string[];
  allowRestrictedPersons: boolean;
  subscriptionAgreementId?: string;
  nonVisibleAppFields?: string[];
  recurring: boolean;
  cardPaymentAccount?: PublicOfferCardPaymentAccountDto;
  externalDetails?: OfferExternalDetailsDto;
}
